var itemClasses = {"item":"Item-module_item__kOQeD","size-small":"Item-module_size-small__BZrfL","selected":"Item-module_selected__pWvP5"};

export { itemClasses as default };
//# sourceMappingURL=Item.module.scss.js.map
